export default __webpack_public_path__ + "static/media/home-pig-candle.1af1aed1.svg";